import React from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetTaskSingle } from "widgets";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import {
  WidgetTaskSinglePreviewQuery,
  WidgetTaskSingleSize,
} from "./__generated__/WidgetTaskSinglePreviewQuery.graphql";

type Props = {
  clientForceSize: WidgetTaskSingleSize;
  taskId: string;
  storecastId: string;
  sectionIds: string[];
};

export function WidgetTaskSinglePreview(props: Props) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <InnerWATaskSinglePreview {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWATaskSinglePreview(props: Props & { fetchKey: string }) {
  const data = useLazyLoadQuery<WidgetTaskSinglePreviewQuery>(
    graphql`
      query WidgetTaskSinglePreviewQuery(
        $input: PreviewWidgetTaskSingleInput!
        $storecastId: ID!
      ) {
        dashboard(id: $storecastId) @required(action: THROW) {
          previewWidgetTaskSingle(input: $input) {
            ...WidgetTaskSingle_widgetTaskSingle
          }
        }
      }
    `,
    {
      input: {
        grouping: "SECTION",
        id: "dummy-id",
        sectionIds: [],
        taskId: props.taskId ?? "",
        taskSingleSize: props.clientForceSize,
        teamIds: [],
      },
      storecastId: props.storecastId,
    },
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  return (
    <WidgetTaskSingle
      mode="IDLE"
      widget={data.dashboard.previewWidgetTaskSingle}
      storecastId={props.storecastId}
      interactive={false}
      clientForceSize={props.clientForceSize}
      clientFilterSectionIds={
        props.sectionIds.length > 0 ? props.sectionIds : undefined
      }
    />
  );
}
